/* @flow */

export enum Setting {
  AutoOpenPlayerDebugPanel = 'autoOpenPlayerDebugPanel',
  AutoPlayNextEpisode = 'autoPlayNextEpisode',
  AutoResume = 'autoResume',
  AutoSelectAudioTrack = 'autoSelectAudioTrack',
  AutoSelectSubtitlesTrack = 'autoSelectSubtitlesTrack',
  BufferBehind = 'bufferBehind',
  BufferingGoal = 'bufferingGoal',
  GreenStreaming = 'greenStreaming',
  LastAudioTrack = 'lastAudioTrack',
  LastSubtitlesTrack = 'lastSubtitlesTrack',
  ParentalControlToggle = 'parentalControlToggle',
  PurchaseLockToggle = 'purchaseLockToggle',
  RebufferingGoal = 'rebufferingGoal',
  Volume = 'volume',
}

export type SettingValue = boolean | number | string;

export type Settings = { [Setting]: SettingValue };
